import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthInfo } from '@core/models/interfaces/auth';
import { ResponseApi } from '@core/models/interfaces/common';
import { Permission } from '@core/models/interfaces/permission/permission';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl = `${environment.API_URL}/crm/auth`;

  constructor(private httpClient: HttpClient) {}

  getLocalToken() {
    return localStorage.getItem('accessToken');
  }

  getLocalUser() {
    return localStorage.getItem('user');
  }

  login(email: string, password: string) {
    return this.httpClient.post<ResponseApi<AuthInfo>>(`${this.baseUrl}/login`, {
      email,
      password
    });
  }

  forgetPassword(email?: string) {
    let params = new HttpParams();
    if (email) {
      params = params.set('email', email);
    }
    return this.httpClient.put(`${this.baseUrl}/forget-password`, null, { params });
  }

  getMyPermission() {
    return this.httpClient.get<ResponseApi<Permission[]>>(`${this.baseUrl}/my-permisison`);
  }

  verifyOTP(otp: string, email: string) {
    return this.httpClient.post<ResponseApi<AuthInfo>>(`${this.baseUrl}/verify-OTP`, { otp, email });
  }

  resendOTP(email: string) {
    return this.httpClient.put(`${this.baseUrl}/${email}/resent-OTP`, {});
  }

  resetPasswordByToken(token: string, newPassword: string) {
    return this.httpClient.put(`${this.baseUrl}/reset-password/by-token`, {
      token,
      newPassword
    });
  }

  resetPasswordByAdmin(userId: string, newPassword: string) {
    return this.httpClient.put(`${this.baseUrl}/reset-password/by-admin`, {
      userId,
      newPassword
    });
  }

  logout(token: string) {
    return this.httpClient.post<ResponseApi<void>>(
      `${this.baseUrl}/logout`,
      {},
      {
        params: {
          token: token
        }
      }
    );
  }
}
